<template>
    <v-app class="bg-light-survey">
        <v-main>
            <v-container class="fill-height justify-center align-center bg-grey-lighten-4">

                <div v-if="checking" class="text-center">
                    <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                    <div class="mt-4 text-h6 grey--text text--darken-1">Verificando enlace...</div>
                </div>

                <v-card v-else-if="!isValid" class="text-center pa-6 rounded-lg" max-width="500" outlined>
                    <v-icon :color="errorMessage.includes('respondida') ? 'green darken-2' : 'red darken-2'" size="72">
                        {{ errorMessage.includes('respondida') ? 'mdi-check-circle-outline' : 'mdi-clock-alert-outline'
                        }}
                    </v-icon>
                    <v-card-title
                        :class="['justify-center', 'headline', 'font-weight-bold', errorMessage.includes('respondida') ? 'green--text text--darken-2' : 'red--text text--darken-2']">
                        {{ errorMessage.includes('respondida') ? 'Encuesta Completada' : 'Enlace Expirado' }}
                    </v-card-title>
                    <v-card-text class="body-1 text-center grey--text text--darken-2 mt-2">
                        {{ errorMessage }}
                    </v-card-text>
                    <v-card-actions class="justify-center mt-4">
                        <v-btn v-if="!errorMessage.includes('respondida')" color="primary" large class="px-6"
                            href="/login">
                            Ir al inicio de sesión
                        </v-btn>
                        <span v-else class="caption grey--text">Ya puedes cerrar esta pestaña.</span>
                    </v-card-actions>
                </v-card>

                <v-card v-else-if="isSubmitted" class="text-center pa-8 rounded-lg" max-width="500" outlined>
                    <v-icon color="green darken-1" size="80">mdi-emoticon-happy-outline</v-icon>
                    <v-card-title class="justify-center headline green--text text--darken-2 font-weight-bold mt-2">
                        ¡Muchas Gracias!
                    </v-card-title>
                    <v-card-text class="body-1 text-center grey--text text--darken-3 mt-3">
                        Tus comentarios y evaluación han sido guardados con éxito.
                        Agradecemos tu tiempo para ayudarnos a seguir mejorando nuestras reuniones.
                    </v-card-text>
                    <v-card-actions class="justify-center mt-4">
                        <span class="caption grey--text">Ya puedes cerrar de forma segura esta ventana.</span>
                    </v-card-actions>
                </v-card>

                <dialog-evaluacion v-else :value="true" :survey="selectedSurvey"
                    @success="onSurveySuccess"></dialog-evaluacion>

            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import DialogEvaluacion from "@/components/DialogEvaluacion.vue";

export default {
    name: 'ExternalSurveyPage',
    components: {
        DialogEvaluacion
    },
    data() {
        return {
            checking: true,
            isValid: false,
            selectedSurvey: null,
            errorMessage: '',
            isSubmitted: false
        }
    },
    mounted() {
        this.verificarEnlaceTemporal();
    },
    methods: {
        async verificarEnlaceTemporal() {
            const queryParams = window.location.search;

            try {
                const response = await this.$axios.get(`verificar-encuesta-temporal${queryParams}`);

                if (response.data.valido) {
                    this.selectedSurvey = response.data.datos;
                    console.log(this.selectedSurvey);
                    this.isValid = true;
                }
            } catch (error) {
                this.isValid = false;
                this.errorMessage = error.response?.data?.message || 'El enlace de acceso no es válido o ha sido alterado.';
            } finally {
                this.checking = false;
            }
        },
        onSurveySuccess() {
            this.isSubmitted = true;
        }
    }
}
</script>

<style scoped>
.bg-light-survey {
    background-color: #f8f9fa;
}
</style>